<template>
    <v-card :dark="active">
        <v-toolbar dense flat :class="titleClass">
            <v-toolbar-title>{{Content.Title}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-side-icon flat :to="Content.Path" @click="onCardSelect()"><v-icon flat>launch</v-icon></v-toolbar-side-icon>
        </v-toolbar>
        <v-card-text>{{Content.ContentDescription}}</v-card-text>
    </v-card>
</template>

<script>
import Insights from '../models/Insights'
import Loader from '../models/App.Loader'
import Modal from '../models/App.Modal'
import { Wait } from '../models/Helpers'

export default {
    props:{
        Content:Object
    },
    computed:{
        active(){
            return this.Content.ContentKey === Insights.nav.Content.active;
        },
        titleClass(){
            let active = (this.active) ? "primary" : "secondary";
            return "title " + active;
        }
    },
    data(){
        return {

        }
    },
    methods:{
        onCardSelect(){
            if(!Modal.lastContent || this.Content.Path !== Modal.lastContent){
                Wait(0,{})
                    .then(response => {
                        Modal.unload();
                        return Wait(0, response);
                    })
                    .then(response => {
                        Loader.show();
                        return Wait(1500, response);
                    })
                    .then(response => {
                        Loader.hide();
                        return Wait(250, response);
                    })
                    .then(() => {
                        Modal.load({
                            Content: this.Content
                        });
                        return false;
                    });
            } else {
                Modal.show();
            }
        }
    },
    mounted(){
        if(this.active){
            this.onCardSelect();
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
